import { useCallback } from "react";
import {
  AddBrandResponse,
  FormData,
  MarketingStrategy,
} from "../types/add-brand-types";
import { useHttpAdapter } from "./useHttpAdapter";
import { getApiErrorMessage } from "../utils/api-error";

type AddBrandApiResponse = Omit<AddBrandResponse, "data"> & {
  data: AddBrandResponse["data"] | AddBrandResponse["data"][];
};

const useBrandApi = () => {
  const { post, patch, del } = useHttpAdapter();

  const addBrand = useCallback(
    async (payload: FormData) => {
      try {
        const competitors = payload.competitors.join(",");
        const response = await post<AddBrandApiResponse>("/addBrand", {
          ...payload,
          competitors: competitors,
        });
        if (response.data.status === "success") {
          return {
            ...response.data,
            data: Array.isArray(response.data.data)
              ? response.data.data[0]
              : response.data.data,
          };
        }
      } catch (error) {
        console.error(error);
        return {
          status: "error",
          message: getApiErrorMessage(error, "Failed to create brand."),
          data: {} as AddBrandResponse["data"],
        };
      }
    },
    [post]
  );

  const updateBrand = useCallback(
    async (payload: Partial<MarketingStrategy>, id: string) => {
      try {
        console.log("::: are you calling :::", payload);
        
        const response = await patch<AddBrandResponse>(`/brand/${id}`, payload);
        if (response.data.status === "success") {
          return response.data;
        }
      } catch (error) {
        console.error(error);
      }
    },
    [patch]
  );

  const deleteBrand = useCallback(
    async (id: string) => {
      try {
        const response = await del<AddBrandResponse>(`/brand/${id}`);
        if (response.data.status === "success") {
          return true;
        }
        return false;
      } catch (error) {
        console.error(error);
        return false;
      }
    },
    [del]
  );

  return { addBrand, updateBrand, deleteBrand };
};

export default useBrandApi;
